import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTable from "@toothfairy/shared-ui/AppTable";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { View, useWindowDimensions } from "react-native";
import { showSideMenu } from "../../../../../App";
import AgentFunctions from "../../../../API/AgentFunctions";
import authorisationsHelper from "../../../../API/Authorisations/authorisationsHelper";
import ToothFairyChoice from "../../../../Components/ToothFairyComponents/ToothFairyChoice";
import ToothFairyButton from "../../../../Components/ToothFairyComponents/ToothFairyButton";
import ToothFairyLoadingPlaceholder from "../../../../Components/ToothFairyComponents/ToothFairyLoadingPlaceholder";
import { useHistory, useParams } from "../../../../Router";

const AuthorisationsList = ({ isFunctionsLoading, setDisplayedView }) => {
  const { currentTheme } = AppTheme.useTheme();
  const { width } = useWindowDimensions();
  const { state, dispatch } = AppStateManager.useAppStateManager();
  const [showChoice, setShowChoice] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const [displayedAuthorisations, setDisplayedAuthorisations] = React.useState(
    []
  );
  const [selectedAuthorisationIds, setSelectedAuthorisationIds] =
    React.useState([]);
  const [showBulkDeleteChoice, setShowBulkDeleteChoice] = React.useState(false);
  const { t } = useTranslation();
  const AppToasty = AppToast.useToast();
  const { height } = useWindowDimensions();
  const history = useHistory();
  const params = useParams();
  useEffect(() => {
    const optId = params?.optId;
    if (!optId) return;
    const wsId = state?.activeWorkspaceID;
    if (!wsId) return;
    if (isLoading) return;
    history.replace(`/workspaces/${wsId}/authorisations/${optId}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.optId, isLoading, state?.activeWorkspaceID]);
  const columns = [
    {
      title: t("settings.list.id"),
      width: 0.00001,
    },
    {
      title: t("settings.list.name"),
      width: 0.25,
    },
    {
      title: t("settings.list.description"),
      // width: 0.45,
    },
    {
      title: t("settings.list.type"),
      width: 0.25,
    },
    {
      title: t("settings.list.actions"),
      isAction: true,
      width: 0.1,
    },
  ];
  const loadAuthorisations = async (workspaceID) => {
    try {
      setIsLoading(true);
      const authorisationsData = await authorisationsHelper.getAuthorisations(
        workspaceID,
        null
      );

      let authorisations =
        authorisationsData?.data?.authorisationsByWorkspace?.items;
      authorisations =
        authorisations
          ?.map((u) => {
            if (u?._deleted !== true)
              return {
                ...u,
                staticArgs: JSON.parse(u?.staticArgs),
              };
          })
          ?.filter((u) => u != null) || [];
      dispatch("SET_AUTHORISATIONS", authorisations || []);

      setDisplayedAuthorisations(authorisations);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    loadAuthorisations(state?.activeWorkspaceID);
  }, [state?.activeWorkspaceID]);
  useEffect(() => {
    setDisplayedAuthorisations([...state?.authorisations]);
  }, [JSON.stringify([...state?.authorisations])]);

  const handleAuthorisationItemSelection = ({ item, index }) => {
    const wsId = state?.activeWorkspaceID;
    if (!wsId || !item?.id) return;
    history.push(`/workspaces/${wsId}/authorisations/${item.id}`);
  };
  const handleAuthorisationItemDeletion = async (item, index) => {
    try {
      setShowChoice(false);
      const _id = selectedItem?.id;
      if (_id) {
        const functionsData =
          await AgentFunctions.getAgentFunctionsByWorkspaceID({
            workspaceID: state?.activeWorkspaceID,
          });
        let functions = functionsData?.data?.functionsByWorkspace?.items;
        functions =
          functions
            ?.map((u) => {
              if (u?.authorisationID === _id)
                return {
                  ...u,
                };
            })
            ?.filter((u) => u != null && u?._deleted != true) || [];
        if (functions.length > 0) {
          AppToasty.show(t("authorisationDeletionErrorCaptionDueToConflict"), {
            type: "danger",
          });
          return;
        }
        const result = await authorisationsHelper.deleteAuthorisation(_id);
        dispatch("SET_AUTHORISATIONS", [
          ...state?.authorisations.filter((u) => u.id !== _id),
        ]);
        AppToasty.show(t("authorisationDeletionSuccessCaption"), {
          type: "success",
        });
        setSelectedIndex(null);
        setSelectedItem(null);
      } else {
        throw new Error(t("settings.list.noItemSelected"));
      }
    } catch (error) {
      console.log(error);
      AppToasty.show(t("authorisationDeletionErrorCaption"), {
        type: "danger",
      });
    }
  };
  const handleBulkDeletion = async () => {
    try {
      let skipped = 0;
      for (const id of selectedAuthorisationIds) {
        const functionsData =
          await AgentFunctions.getAgentFunctionsByWorkspaceID({
            workspaceID: state?.activeWorkspaceID,
          });
        const inUse = (functionsData?.data?.functionsByWorkspace?.items || [])
          .filter((u) => u != null && u?._deleted != true)
          .some((u) => u?.authorisationID === id);
        if (inUse) {
          skipped += 1;
          continue;
        }
        await authorisationsHelper.deleteAuthorisation(id);
      }
      dispatch("SET_AUTHORISATIONS", [
        ...state?.authorisations.filter(
          (u) => !selectedAuthorisationIds.includes(u.id)
        ),
      ]);
      setSelectedAuthorisationIds([]);
      setShowBulkDeleteChoice(false);
      if (skipped > 0) {
        AppToasty.show(t("authorisationDeletionErrorCaptionDueToConflict"), {
          type: "danger",
        });
      } else {
        AppToasty.show(t("authorisationDeletionSuccessCaption"), {
          type: "success",
        });
      }
    } catch (error) {
      console.log(error);
      setShowBulkDeleteChoice(false);
      AppToasty.show(t("authorisationDeletionErrorCaption"), {
        type: "danger",
      });
    }
  };
  const handleCreation = () => {
    const wsId = state?.activeWorkspaceID;
    if (!wsId) return;
    history.push(`/workspaces/${wsId}/authorisations/new`);
  };
  const _coreChoice = useMemo(() => {
    return (
      <ToothFairyChoice
        cancelCaption={t("settings.list.cancel")}
        caption={t("settings.list.deleteAuthorisationConfirmation")}
        subCaption={t("settings.list.deleteAuthorisationConfirmationMessage")}
        confirmCaption={t("settings.list.delete")}
        onCancelButtonPress={() => setShowChoice(false)}
        onConfirmButtonPress={() => handleAuthorisationItemDeletion()}
        setShowChoice={setShowChoice}
        showChoice={showChoice}
      />
    );
  }, [setShowChoice, showChoice, selectedItem, setSelectedItem]);
  const _bulkDeleteChoice = useMemo(() => {
    return (
      <ToothFairyChoice
        cancelCaption={t("settings.list.cancelConfirmation")}
        caption={t("settings.list.deleteSelectedConfirmation", {
          defaultValue: t("settings.list.deleteAuthorisationConfirmation"),
        })}
        subCaption={t("settings.list.deleteAuthorisationConfirmationMessage")}
        confirmCaption={t("settings.list.delete")}
        onCancelButtonPress={() => setShowBulkDeleteChoice(false)}
        onConfirmButtonPress={handleBulkDeletion}
        setShowChoice={setShowBulkDeleteChoice}
        showChoice={showBulkDeleteChoice}
      />
    );
  }, [showBulkDeleteChoice, selectedAuthorisationIds]);

  return (
    <View
      style={{
        paddingLeft: 10,
        flex: 1,
        width: showSideMenu() ? width - 220 : "100%",
        minWidth: "100%",
        overflow: isLoading && "hidden",
      }}
    >
      <>
        {isLoading ? (
          <ToothFairyLoadingPlaceholder
            backgroundColor={currentTheme?.theme?.softBackgroundColor}
            visible={true}
            containerStyle={{
              backgroundColor: currentTheme?.theme?.transparent,
              minHeight: 250,
            }}
            caption={t("settings.list.loadingAuthorisations")}
          />
        ) : (
          <>
            {displayedAuthorisations.length > 0 ? (
              <AppTable
                isSelectable
                showPagination
                itemsPerPage={50}
                hideSearch={false}
                searchPlaceholder={t(
                  "settings.toolbar.searchByNameOrDescription"
                )}
                onSelectionChange={(selectedItems) => {
                  setSelectedAuthorisationIds(
                    selectedItems?.map((u) => u?.id) || []
                  );
                }}
                bulkActions={[
                  {
                    id: "DELETE",
                    label: t("settings.list.delete"),
                    icon: AppAssets.icons.delete,
                    isDestructive: true,
                  },
                ]}
                onBulkActionPress={(id) => {
                  if (id === "DELETE" && selectedAuthorisationIds?.length > 0)
                    setShowBulkDeleteChoice(true);
                }}
                actionButtons
                showDropDownMenuForActions
                mainActionLabel={t("settings.list.edit")}
                onClickMainAction={(item, index) => {
                  handleAuthorisationItemSelection({
                    id: item?.id,
                    item,
                    index,
                  });
                }}
                onActionItemPress={(id, item, index) => {
                  if (id === "EDIT") {
                    handleAuthorisationItemSelection({
                      id: item?.id,
                      item,
                      index,
                    });
                  } else if (id === "DELETE") {
                    setSelectedItem(item);
                    setSelectedIndex(index);
                    setShowChoice(true);
                  }
                }}
                actions={[
                  {
                    label: t("settings.list.edit"),
                    id: "EDIT",
                    icon: AppAssets.icons.edit,
                  },
                  {
                    label: t("settings.list.delete"),
                    id: "DELETE",
                    icon: AppAssets.icons.delete,
                  },
                ]}
                style={{
                  zIndex: -1,
                  marginTop: 15,
                  height:
                    displayedAuthorisations?.length >= 50
                      ? height - 95
                      : height - 75,
                  paddingRight: 0,
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
                headers={columns}
                items={displayedAuthorisations
                  ?.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""))
                  ?.map((u) => {
                    return {
                      id: u?.id,
                      name: u?.name || " ",
                      description: u?.description || " ",
                      type: u?.type?.toUpperCase() || " ",
                      actions: " ",
                    };
                  })}
              >
                <ToothFairyButton
                  title={t("settings.toolbar.create")}
                  onPress={handleCreation}
                />
              </AppTable>
            ) : (
              <AppPlaceholderView
                wrapperStyle={{
                  width: "100%",
                  height: "100%",
                  marginVertical: 60,
                  marginHorizontal: "auto",
                  flex: 1,
                  zIndex: -1,
                }}
                size={30}
                icon={AppAssets.icons.credentials}
                mainCaption={t("settings.list.noAuthorisationsFound")}
                subCaption={t("settings.list.noAuthorisationsFoundSub")}
                actionLabel={t("settings.toolbar.create")}
                onActionPress={handleCreation}
              />
            )}
          </>
        )}
      </>

      {_coreChoice}
      {_bulkDeleteChoice}
    </View>
  );
};

export default AuthorisationsList;
